import React, { useState, useEffect } from 'react';

import { Box, CircularProgress, Typography } from '@datanomik/commons-ui';
import { t } from 'i18next';

export const LoadingLayout = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + (Math.random() * 5 + 5);
        return (newProgress > 100) ? 100 : newProgress;
      });
    }, 180);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{
      position: 'relative',
      height: '100vh',
      width: '100vw',
      background: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '15px',
    }}
    >
      <Box>
        <Box sx={{
          position: 'relative',
          display: 'inline-flex',
        }}
        >
          <CircularProgress
            variant="determinate"
            value={progress}
            size={64}
            color="primary"
          />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="p4"
              sx={{ color: 'neutral.900', fontWeight: 'bold' }}
            >
              {`${Math.round(progress)}%`}
            </Typography>
          </Box>

        </Box>
      </Box>

      <Typography
        variant="p4"
        sx={{ color: 'neutral.900' }}
      >
        {t('Loading information')}
      </Typography>

    </Box>
  );
};
